import React, { useState, useEffect } from "react";
import "./Header.css";
// Import your logo image (make sure to add it to your project)
import logo from "./logo.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const quote =
    "🏆 ISO 9001:2015 Certified | Building Excellence with Precision & Pride";
  const email = "info@workmates.co.in";
  const phone = "Landline No.: +91 8766527422";

  return (
    <>
      <div className="topbar">
        <div className="topbar-container">
          <div className="topbar-quote">
            <marquee>
              <span className="quote-icon"></span>
              {quote}
            </marquee>
          </div>
          <div className="topbar-contact">
            <a href={`mailto:${email}`} className="topbar-email">
              <span className="contact-icon">✉</span>
              {email}
            </a>
            <a
              href={`tel:${phone.replace(/\D/g, "")}`}
              className="topbar-phone"
            >
              <span className="contact-icon">📞</span>
              {phone}
            </a>
          </div>
        </div>
      </div>

      <header className={`header ${isScrolled ? "scrolled" : ""}`}>
        <div className="container">
          <a href="/">
            <div className="logo">
              <img src={logo} alt="BuildMaster Construction" />
            </div>
          </a>

          <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
            <ul className="nav-list">
              <li>
                <a href="/home" onClick={closeMenu}>
                  Home
                </a>
              </li>
              <li>
                <a href="/aboutus" onClick={closeMenu}>
                  About Us
                </a>
              </li>
              <li>
                <a href="/key-offering" onClick={closeMenu}>
                  Key Offering
                </a>
              </li>
              <li>
                <a href="/complete-projects" onClick={closeMenu}>
                  Completed Projects
                </a>
              </li>
              <li>
                <a href="/resources" onClick={closeMenu}>
                  Resources
                </a>
              </li>
              <li>
                <a href="/gallery" onClick={closeMenu}>
                  Gallery
                </a>
              </li>
              <li>
                <a href="/contactus" onClick={closeMenu}>
                  Contact Us
                </a>
              </li>
              <li className="login-button">
                <a
                  href="https://crm.workmates.co.in/"
                  onClick={closeMenu}
                  className="blinking-login"
                  target="_blank"
                >
                  Login
                </a>
              </li>
            </ul>
          </nav>

          <button
            className={`hamburger ${isMenuOpen ? "hamburger-open" : ""}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>
    </>
  );
};

export default Header;
